import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import { getQuizById, updateQuiz } from "../../../../api/quiz";
import { getTexts, createText, updateText } from "../../../../api/text";
import { uploadSingleFile } from "../../../../api/files";
import { SERVER_URL } from "../../../../api";
import { alertError, alertSuccess } from "../../../../utils/logger";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Tooltip } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import AddIcon from "@material-ui/icons/Add";
import Editor from "../../../components/editor/Editor";
import { getDefaultQuizOptions, isScenario2Quiz, isScenario3Quiz, isScenario5Quiz, isScenario52Quiz, isScenario52Question2Quiz, isScenario6Quiz, isScenario7Quiz, isScenario72Quiz, isScenario73Quiz, isSupertestQuiz, explanationPreview } from "./getDefaultQuizOptions";
import { stripExplanationPrefix } from "./explanationHelpers";
import { DEFAULT_SCENARIO7_FILTER_LABELS } from "./defaultScenario7Options";

function buildImageUrl(value) {
  if (!value || typeof value !== "string") return null;
  if (value.startsWith("http")) return value;
  return `${SERVER_URL.replace(/\/$/, "")}/${value.replace(/^\//, "")}`;
}

const DEFAULT_SCENARIO6_FILTERS = [
  "≥30 % de reducción",
  ">20 % y <30 % de reducción",
  "≤20 % de reducción",
];

export default function EditQuizPage() {
  const { id: quizId } = useParams();
  const history = useHistory();
  const [quizData, setQuizData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [editingPruebasOptions, setEditingPruebasOptions] = useState([]);
  const [savingPruebas, setSavingPruebas] = useState(false);
  const [editingIndex, setEditingIndex] = useState(null);
  const [editingOne, setEditingOne] = useState(null);
  const [editingFilterLabels, setEditingFilterLabels] = useState([...DEFAULT_SCENARIO6_FILTERS]);
  const [savingFilters, setSavingFilters] = useState(false);
  const [scenario72Title, setScenario72Title] = useState("");
  const [scenario72TitleRecordId, setScenario72TitleRecordId] = useState(null);
  const [scenario72GameId, setScenario72GameId] = useState(null);
  const [savingScenario72Title, setSavingScenario72Title] = useState(false);
  const [scenario73Title, setScenario73Title] = useState("");
  const [scenario73TitleRecordId, setScenario73TitleRecordId] = useState(null);
  const [scenario73GameId, setScenario73GameId] = useState(null);
  const [savingScenario73Title, setSavingScenario73Title] = useState(false);
  const [supertestResultExplanation, setSupertestResultExplanation] = useState("");
  const [savingSupertestResult, setSavingSupertestResult] = useState(false);
  const [supertestScreenTitle, setSupertestScreenTitle] = useState("");
  const [supertestLegend, setSupertestLegend] = useState("");
  const [savingSupertestTitleLegend, setSavingSupertestTitleLegend] = useState(false);
  const [supertestEditField, setSupertestEditField] = useState(null);

  useEffect(() => {
    getQuizById(quizId)
      .then((res) => {
        if (res.status === 200 && res.data) {
          const data = res.data;
          setQuizData(data);
          let opts = data.options && data.options.length > 0
            ? data.options.map((o) => ({ ...o }))
            : getDefaultQuizOptions(data).map((o) => ({ ...o }));
          if (isScenario7Quiz(data) && (!opts || opts.length !== 9)) {
            opts = getDefaultQuizOptions(data).map((o) => ({ ...o }));
          }
          if (isScenario6Quiz(data)) {
            opts = opts.map((o) => ({
              ...o,
              correct: typeof o.explanation === "string" && /^[0123]$/.test(o.explanation) ? Number(o.explanation) : (typeof o.correct === "number" && o.correct >= 0 && o.correct <= 3 ? o.correct : 0),
            }));
          }
          setEditingPruebasOptions(opts);
          if (isScenario6Quiz(data)) {
            if (data.filterLabels && Array.isArray(data.filterLabels) && data.filterLabels.length >= 3) {
              setEditingFilterLabels([
                data.filterLabels[0] ?? DEFAULT_SCENARIO6_FILTERS[0],
                data.filterLabels[1] ?? DEFAULT_SCENARIO6_FILTERS[1],
                data.filterLabels[2] ?? DEFAULT_SCENARIO6_FILTERS[2],
              ]);
            } else {
              setEditingFilterLabels([...DEFAULT_SCENARIO6_FILTERS]);
            }
          }
          if (isScenario7Quiz(data)) {
            if (data.filterLabels && Array.isArray(data.filterLabels) && data.filterLabels.length >= 3) {
              setEditingFilterLabels([
                data.filterLabels[0] ?? DEFAULT_SCENARIO7_FILTER_LABELS[0],
                data.filterLabels[1] ?? DEFAULT_SCENARIO7_FILTER_LABELS[1],
                data.filterLabels[2] ?? DEFAULT_SCENARIO7_FILTER_LABELS[2],
              ]);
            } else {
              setEditingFilterLabels([...DEFAULT_SCENARIO7_FILTER_LABELS]);
            }
          }
          if (isSupertestQuiz(data)) {
            setSupertestResultExplanation(data.resultExplanation ?? "");
            setSupertestScreenTitle(data.screenTitle ?? "");
            setSupertestLegend(data.legend ?? "");
          }
        }
      })
      .catch((err) => {
        alertError({ error: err, customMessage: "No se pudo cargar el quiz." });
      })
      .finally(() => setLoading(false));
  }, [quizId]);

  useEffect(() => {
    if (!quizData || !isScenario72Quiz(quizData)) return;
    const gameId = quizData.scenario?.game?._id || quizData.scenario?.game;
    if (!gameId) return;
    getTexts({ game: gameId })
      .then((res) => {
        if (res.status === 200 && Array.isArray(res.data)) {
          const rec = res.data.find((t) => t.key === "scenario7.2.title");
          setScenario72GameId(gameId);
          if (rec) {
            setScenario72Title(rec.value ?? "");
            setScenario72TitleRecordId(rec._id);
          } else {
            setScenario72Title("¿Qué recomiendan otras sociedades científicas acerca de la duración del tratamiento?");
            setScenario72TitleRecordId(null);
          }
        }
      })
      .catch(() => {});
  }, [quizData]);

  useEffect(() => {
    if (!quizData || !isScenario73Quiz(quizData)) return;
    const gameId = quizData.scenario?.game?._id || quizData.scenario?.game;
    if (!gameId) return;
    getTexts({ game: gameId })
      .then((res) => {
        if (res.status === 200 && Array.isArray(res.data)) {
          const rec = res.data.find((t) => t.key === "scenario7.3.title");
          setScenario73GameId(gameId);
          if (rec) {
            setScenario73Title(rec.value ?? "");
            setScenario73TitleRecordId(rec._id);
          } else {
            setScenario73Title("¿Qué recomiendan otras sociedades científicas acerca de la duración del tratamiento?");
            setScenario73TitleRecordId(null);
          }
        }
      })
      .catch(() => {});
  }, [quizData]);

  const isScenario7Duration = quizData && isScenario7Quiz(quizData) && ((quizData.options && quizData.options.length === 9) || (editingPruebasOptions && editingPruebasOptions.length === 9));

  const saveScenario72Title = async () => {
    if (!scenario72GameId) return;
    setSavingScenario72Title(true);
    try {
      if (scenario72TitleRecordId) {
        await updateText(scenario72TitleRecordId, { value: scenario72Title });
      } else {
        await createText({
          game: scenario72GameId,
          key: "scenario7.2.title",
          order: 82,
          scenario: 7,
          value: scenario72Title,
        });
        const res = await getTexts({ game: scenario72GameId });
        if (res.status === 200 && Array.isArray(res.data)) {
          const rec = res.data.find((t) => t.key === "scenario7.2.title");
          if (rec) setScenario72TitleRecordId(rec._id);
        }
      }
      alertSuccess({ customMessage: "Título guardado." });
    } catch (err) {
      alertError({ error: err, customMessage: "No se pudo guardar el título." });
    } finally {
      setSavingScenario72Title(false);
    }
  };

  const saveScenario73Title = async () => {
    if (!scenario73GameId) return;
    setSavingScenario73Title(true);
    try {
      if (scenario73TitleRecordId) {
        await updateText(scenario73TitleRecordId, { value: scenario73Title });
      } else {
        await createText({
          game: scenario73GameId,
          key: "scenario7.3.title",
          order: 83,
          scenario: 7,
          value: scenario73Title,
        });
        const res = await getTexts({ game: scenario73GameId });
        if (res.status === 200 && Array.isArray(res.data)) {
          const rec = res.data.find((t) => t.key === "scenario7.3.title");
          if (rec) setScenario73TitleRecordId(rec._id);
        }
      }
      alertSuccess({ customMessage: "Título guardado." });
    } catch (err) {
      alertError({ error: err, customMessage: "No se pudo guardar el título." });
    } finally {
      setSavingScenario73Title(false);
    }
  };

  const openEditOne = (index) => {
    const isScenario7 = quizData && isScenario7Quiz(quizData);
    const isScenario72 = quizData && isScenario72Quiz(quizData);
    const isSupertest = quizData && isSupertestQuiz(quizData);
    if (isScenario7) {
      const itemIndex = index;
      const labels = Array.isArray(editingFilterLabels) && editingFilterLabels.length >= 3 ? editingFilterLabels : DEFAULT_SCENARIO7_FILTER_LABELS;
      setEditingIndex(itemIndex);
      setEditingOne({
        label: labels[itemIndex] ?? "",
        options: editingPruebasOptions.slice(itemIndex * 3, itemIndex * 3 + 3).map((o) => ({ id: o.id, text: o.text || "", correct: !!o.correct })),
      });
      return;
    }
    const opt = editingPruebasOptions[index];
    if (!opt) return;
    setEditingIndex(index);
    const isScenario6 = quizData && isScenario6Quiz(quizData);
    const is72 = quizData && isScenario72Quiz(quizData);
    const is73 = quizData && isScenario73Quiz(quizData);
    setEditingOne(
      isSupertest
        ? { ...opt, explanation: "", confirmExplanation: "" }
        : is72 || is73
        ? { ...opt, explanation: opt.explanation || "", confirmExplanation: opt.confirmExplanation || "" }
        : {
            ...opt,
            explanation: isScenario6 ? (opt.explanation || "") : stripExplanationPrefix(opt.explanation || ""),
            ...(isScenario6 && { correct: Number(opt.explanation) || 0 }),
          }
    );
  };

  const closeEditOne = () => {
    setEditingIndex(null);
    setEditingOne(null);
  };

  const addSupertestOption = () => {
    if (!quizData || !isSupertestQuiz(quizData)) return;
    setEditingPruebasOptions((prev) => [
      ...prev,
      { id: prev.length + 1, text: "", correct: false, explanation: "", confirmExplanation: "" },
    ]);
  };

  const removeSupertestOption = async (index) => {
    if (!quizId || !quizData || !isSupertestQuiz(quizData)) return;
    const prev = editingPruebasOptions;
    if (prev.length <= 1) return;
    const nextOptions = prev.filter((_, i) => i !== index).map((opt, i) => ({ ...opt, id: i + 1 }));
    setEditingPruebasOptions(nextOptions);
    if (editingIndex === index) closeEditOne();
    else if (editingIndex != null && editingIndex > index) setEditingIndex((prev) => prev - 1);
    setSavingPruebas(true);
    try {
      const payload = {
        fullName: quizData.fullName,
        scenario: typeof quizData.scenario === "object" ? quizData.scenario._id : quizData.scenario,
        options: nextOptions.map((opt, idx) => ({ id: Number(opt.id) || idx + 1, text: opt.text || "", correct: !!opt.correct, explanation: "", confirmExplanation: "" })),
        resultExplanation: supertestResultExplanation ?? "",
        screenTitle: supertestScreenTitle ?? "",
        legend: supertestLegend ?? "",
      };
      const res = await updateQuiz(quizId, payload);
      if (res.status === 200 && res.data) {
        setQuizData(res.data);
        setEditingPruebasOptions(res.data.options ? res.data.options.map((o) => ({ ...o })) : nextOptions);
        alertSuccess({ customMessage: "Opción eliminada." });
      }
    } catch (err) {
      alertError({ error: err, customMessage: "No se pudo eliminar la opción." });
      setEditingPruebasOptions(prev);
    } finally {
      setSavingPruebas(false);
    }
  };

  const updateEditingOne = (field, value) => {
    const isScenario7 = quizData && isScenario7Quiz(quizData);
    if (isScenario7 && editingOne && (field === "option0" || field === "option1" || field === "option2")) {
      const idx = parseInt(field.replace("option", ""), 10);
      setEditingOne((prev) => (prev ? { ...prev, options: prev.options.map((o, i) => (i === idx ? { ...o, text: value } : o)) } : null));
      return;
    }
    if (isScenario7 && editingOne && field === "correctIndex") {
      const v = parseInt(value, 10);
      setEditingOne((prev) => (prev ? { ...prev, options: prev.options.map((o, i) => ({ ...o, correct: i === v })) } : null));
      return;
    }
    setEditingOne((prev) => (prev ? { ...prev, [field]: value } : null));
  };

  const buildScenario6Payload = (opts) => {
    if (!quizData) return null;
    return {
      fullName: quizData.fullName,
      scenario: typeof quizData.scenario === "object" ? quizData.scenario._id : quizData.scenario,
      options: opts.map((opt) => ({
        id: opt.id,
        text: opt.text || "",
        correct: false,
        explanation: String(Number(opt.correct) || 0),
        confirmExplanation: opt.confirmExplanation || "",
      })),
      filterLabels: Array.isArray(editingFilterLabels) && editingFilterLabels.length >= 3 ? editingFilterLabels : DEFAULT_SCENARIO6_FILTERS,
    };
  };

  const saveFilters = async () => {
    if (!quizId || !quizData || !isScenario6Quiz(quizData)) return;
    const payload = buildScenario6Payload(editingPruebasOptions);
    if (!payload) return;
    setSavingFilters(true);
    try {
      const res = await updateQuiz(quizId, payload);
      if (res.status === 200 && res.data) {
        setQuizData(res.data);
        alertSuccess({ customMessage: "Filtros guardados." });
      }
    } catch (err) {
      alertError({ error: err, customMessage: "No se pudo guardar." });
    } finally {
      setSavingFilters(false);
    }
  };

  const saveEditOne = async () => {
    if (editingIndex == null || !editingOne || !quizId || !quizData) return;
    if (isScenario7Quiz(quizData)) {
      const itemIndex = editingIndex;
      const newLabels = [...(Array.isArray(editingFilterLabels) && editingFilterLabels.length >= 3 ? editingFilterLabels : DEFAULT_SCENARIO7_FILTER_LABELS)];
      newLabels[itemIndex] = editingOne.label ?? newLabels[itemIndex];
      const nextOptions = [...editingPruebasOptions];
      editingOne.options.forEach((o, j) => {
        const idx = itemIndex * 3 + j;
        if (nextOptions[idx]) nextOptions[idx] = { ...nextOptions[idx], text: o.text, correct: o.correct };
      });
      setSavingPruebas(true);
      try {
        const payload = {
          fullName: quizData.fullName,
          scenario: typeof quizData.scenario === "object" ? quizData.scenario._id : quizData.scenario,
          options: nextOptions.map((opt) => ({ id: opt.id, text: opt.text || "", correct: !!opt.correct, explanation: "" })),
          filterLabels: newLabels,
        };
        const res = await updateQuiz(quizId, payload);
        if (res.status === 200 && res.data) {
          setQuizData(res.data);
          setEditingPruebasOptions(res.data.options || nextOptions);
          setEditingFilterLabels(res.data.filterLabels && res.data.filterLabels.length >= 3 ? [...res.data.filterLabels] : newLabels);
          alertSuccess({ customMessage: "Apartado guardado." });
          closeEditOne();
        }
      } catch (err) {
        alertError({ error: err, customMessage: "No se pudo guardar." });
      } finally {
        setSavingPruebas(false);
      }
      return;
    }
    const nextOptions = [...editingPruebasOptions];
    nextOptions[editingIndex] = { ...editingOne };
    const useOrderLabels = isScenario2Quiz(quizData);
    const useScenario3 = isScenario3Quiz(quizData);
    const useScenario5 = isScenario5Quiz(quizData);
    const useScenario52 = isScenario52Quiz(quizData) || isScenario52Question2Quiz(quizData);
    const useScenario6 = isScenario6Quiz(quizData);
    const useSupertest = isSupertestQuiz(quizData);
    setSavingPruebas(true);
    try {
      const payload = {
        fullName: quizData.fullName,
        scenario: typeof quizData.scenario === "object" ? quizData.scenario._id : quizData.scenario,
        options: nextOptions.map((opt, idx) =>
          useSupertest
            ? { id: Number(opt.id) || idx + 1, text: opt.text || "", correct: !!opt.correct, explanation: "", confirmExplanation: "" }
            : {
                id: opt.id,
                text: useOrderLabels ? `Diagnóstico ${idx + 1}` : useScenario52 ? (opt.text || "") : useScenario5 ? String.fromCharCode(97 + idx) + ")" : (opt.text || ""),
                correct: useScenario6 ? false : !!opt.correct,
                explanation: useScenario6 ? String(Number(opt.correct) || 0) : (stripExplanationPrefix(opt.explanation || "") || ""),
                confirmExplanation: opt.confirmExplanation || "",
                ...(useScenario3 && { image: opt.image || "" }),
              }
        ),
        ...(useScenario6 && { filterLabels: Array.isArray(editingFilterLabels) && editingFilterLabels.length >= 3 ? editingFilterLabels : DEFAULT_SCENARIO6_FILTERS }),
        ...(useSupertest && {
          resultExplanation: supertestResultExplanation ?? "",
          screenTitle: supertestScreenTitle ?? "",
          legend: supertestLegend ?? "",
        }),
      };
      const res = await updateQuiz(quizId, payload);
      if (res.status === 200 && res.data) {
        setQuizData(res.data);
        const nextOpts = res.data.options ? res.data.options.map((o) => {
          const copy = { ...o };
          if (isScenario6Quiz(res.data)) {
            copy.correct = typeof o.explanation === "string" && /^[0123]$/.test(o.explanation) ? Number(o.explanation) : 0;
          }
          return copy;
        }) : nextOptions;
        setEditingPruebasOptions(nextOpts);
        alertSuccess({ customMessage: "Prueba guardada." });
        closeEditOne();
      }
    } catch (err) {
      alertError({ error: err, customMessage: "No se pudo guardar." });
    } finally {
      setSavingPruebas(false);
    }
  };

  async function saveSupertestResultExplanation() {
    if (!quizData || !isSupertestQuiz(quizData)) return;
    setSavingSupertestResult(true);
    try {
      const payload = {
        fullName: quizData.fullName,
        scenario: typeof quizData.scenario === "object" ? quizData.scenario._id : quizData.scenario,
        resultExplanation: supertestResultExplanation ?? "",
      };
      const res = await updateQuiz(quizId, payload);
      if (res.status === 200 && res.data) {
        setQuizData(res.data);
        alertSuccess({ customMessage: "Texto del modal de resultado guardado." });
      }
    } catch (err) {
      alertError({ error: err, customMessage: "No se pudo guardar." });
    } finally {
      setSavingSupertestResult(false);
    }
  }

  async function saveSupertestTitleLegend() {
    if (!quizData || !isSupertestQuiz(quizData)) return;
    setSavingSupertestTitleLegend(true);
    try {
      const payload = {
        fullName: quizData.fullName,
        scenario: typeof quizData.scenario === "object" ? quizData.scenario._id : quizData.scenario,
        screenTitle: supertestScreenTitle ?? "",
        legend: supertestLegend ?? "",
      };
      const res = await updateQuiz(quizId, payload);
      if (res.status === 200 && res.data) {
        setQuizData(res.data);
        alertSuccess({ customMessage: "Título y leyenda guardados." });
      }
    } catch (err) {
      alertError({ error: err, customMessage: "No se pudo guardar." });
    } finally {
      setSavingSupertestTitleLegend(false);
    }
  }

  if (loading) {
    return (
      <Card>
        <CardBody>Cargando…</CardBody>
      </Card>
    );
  }

  if (!quizData) {
    return (
      <Card>
        <CardBody>Quiz no encontrado.</CardBody>
      </Card>
    );
  }

  return (
    <>
      <Card>
        <CardHeader title={`Editar quiz: ${quizData.fullName}`}>
          <CardHeaderToolbar>
            <Button variant="outlined" onClick={() => history.push("/quizzes")}>
              Volver a Quizzes
            </Button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <p className="text-muted mb-4">
            {(isScenario72Quiz(quizData) || isScenario73Quiz(quizData))
              ? "Scenario 7-2/7-3 (EULAR/KDIGO): edita el título de la pantalla, el enunciado de la afirmación, si es Verdadero o Falso, la justificación (tras responder) y la cita que se muestra bajo el enunciado."
              : isSupertestQuiz(quizData)
              ? "Supertest: edita el texto de cada opción (a), b), c)... en la web) y marca cuál es la respuesta correcta."
              : isScenario3Quiz(quizData)
              ? "Diagnóstico por imagen: edita la etiqueta y la imagen de cada opción. Cada fila es una etiqueta y su imagen asociada."
              : isScenario6Quiz(quizData)
              ? "Ajuste de dosis: edita los textos de los filtros y el texto de cada recomendación y para qué filtro (≥30 %, >20-30 %, ≤20 %) es la correcta."
              : isScenario7Duration
              ? "Tiempo de tratamiento: 3 apartados (MPAA, Ciclofosfamida, ICN). Edita el título de cada apartado y las 3 opciones, e indica cuál es la correcta."
              : "Listado de pruebas. Usa Editar en cada fila para cambiar nombre, si está justificada y la justificación. El número de pruebas justificadas lo defines tú (marcando el checkbox al editar)."}
          </p>
          {isScenario72Quiz(quizData) && (
            <div className="mb-4 p-3 border rounded">
              <div className="small font-weight-bold mb-2">Título de la pantalla (¿Qué recomiendan otras sociedades científicas acerca de la duración del tratamiento?)</div>
              <div className="form-row mb-2">
                <div className="col">
                  <input
                    type="text"
                    className="form-control"
                    value={scenario72Title}
                    onChange={(e) => setScenario72Title(e.target.value ?? "")}
                    placeholder="¿Qué recomiendan otras sociedades científicas acerca de la duración del tratamiento?"
                  />
                </div>
              </div>
              <Button variant="outlined" size="small" onClick={saveScenario72Title} disabled={savingScenario72Title || !scenario72GameId}>
                {savingScenario72Title ? "Guardando…" : "Guardar título"}
              </Button>
            </div>
          )}
          {isScenario73Quiz(quizData) && (
            <div className="mb-4 p-3 border rounded">
              <div className="small font-weight-bold mb-2">Título de la pantalla (¿Qué recomiendan otras sociedades científicas acerca de la duración del tratamiento?)</div>
              <div className="form-row mb-2">
                <div className="col">
                  <input
                    type="text"
                    className="form-control"
                    value={scenario73Title}
                    onChange={(e) => setScenario73Title(e.target.value ?? "")}
                    placeholder="¿Qué recomiendan otras sociedades científicas acerca de la duración del tratamiento?"
                  />
                </div>
              </div>
              <Button variant="outlined" size="small" onClick={saveScenario73Title} disabled={savingScenario73Title || !scenario73GameId}>
                {savingScenario73Title ? "Guardando…" : "Guardar título"}
              </Button>
            </div>
          )}
          {isSupertestQuiz(quizData) && (
            <div className="mb-4">
              <div className="small font-weight-bold mb-2">Título, leyenda y justificación del modal</div>
              <div className="table-responsive">
                <table className="table table-bordered table-hover">
                  <thead>
                    <tr>
                      <th>Campo</th>
                      <th style={{ width: 100 }} className="text-center">Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Título (enunciado) de la pregunta</td>
                      <td className="text-center">
                        <Tooltip title="Editar">
                          <Button size="small" onClick={() => setSupertestEditField("screenTitle")}>
                            <EditIcon />
                          </Button>
                        </Tooltip>
                      </td>
                    </tr>
                    <tr>
                      <td>Leyenda</td>
                      <td className="text-center">
                        <Tooltip title="Editar">
                          <Button size="small" onClick={() => setSupertestEditField("legend")}>
                            <EditIcon />
                          </Button>
                        </Tooltip>
                      </td>
                    </tr>
                    <tr>
                      <td>Texto en el modal de resultado (justificación)</td>
                      <td className="text-center">
                        <Tooltip title="Editar">
                          <Button size="small" onClick={() => setSupertestEditField("resultExplanation")}>
                            <EditIcon />
                          </Button>
                        </Tooltip>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          )}
          {isScenario6Quiz(quizData) && (
            <div className="mb-4 p-3 border rounded">
              <div className="small font-weight-bold mb-2">Textos de los filtros (columna izquierda)</div>
              <div className="form-row mb-2">
                <div className="col">
                  <label className="small">Filtro 1</label>
                  <input
                    type="text"
                    className="form-control"
                    value={Array.isArray(editingFilterLabels) ? (editingFilterLabels[0] ?? "") : ""}
                    onChange={(e) => {
                      const v = e?.target?.value ?? "";
                      setEditingFilterLabels((prev) => {
                        const p = Array.isArray(prev) && prev.length >= 3 ? prev : [...DEFAULT_SCENARIO6_FILTERS];
                        return [v, p[1], p[2]];
                      });
                    }}
                  />
                </div>
              </div>
              <div className="form-row mb-2">
                <div className="col">
                  <label className="small">Filtro 2</label>
                  <input
                    type="text"
                    className="form-control"
                    value={Array.isArray(editingFilterLabels) ? (editingFilterLabels[1] ?? "") : ""}
                    onChange={(e) => {
                      const v = e?.target?.value ?? "";
                      setEditingFilterLabels((prev) => {
                        const p = Array.isArray(prev) && prev.length >= 3 ? prev : [...DEFAULT_SCENARIO6_FILTERS];
                        return [p[0], v, p[2]];
                      });
                    }}
                  />
                </div>
              </div>
              <div className="form-row mb-2">
                <div className="col">
                  <label className="small">Filtro 3</label>
                  <input
                    type="text"
                    className="form-control"
                    value={Array.isArray(editingFilterLabels) ? (editingFilterLabels[2] ?? "") : ""}
                    onChange={(e) => {
                      const v = e?.target?.value ?? "";
                      setEditingFilterLabels((prev) => {
                        const p = Array.isArray(prev) && prev.length >= 3 ? prev : [...DEFAULT_SCENARIO6_FILTERS];
                        return [p[0], p[1], v];
                      });
                    }}
                  />
                </div>
              </div>
              <Button variant="outlined" size="small" onClick={saveFilters} disabled={savingFilters}>
                {savingFilters ? "Guardando…" : "Guardar filtros"}
              </Button>
            </div>
          )}
          <div className="table-responsive">
            <table className="table table-bordered table-hover">
              <thead>
                <tr>
                  <th style={{ width: 80 }}>#</th>
                  <th>{(isScenario72Quiz(quizData) || isScenario73Quiz(quizData)) ? "Enunciado" : isSupertestQuiz(quizData) ? "Opción" : isScenario7Quiz(quizData) ? "Apartado" : isScenario3Quiz(quizData) ? "Etiqueta" : (isScenario52Quiz(quizData) || isScenario52Question2Quiz(quizData)) ? "Afirmación" : isScenario2Quiz(quizData) || isScenario5Quiz(quizData) ? "Justificación" : isScenario6Quiz(quizData) ? "Recomendación" : "Nombre"}</th>
                  {isScenario3Quiz(quizData) && <th style={{ width: 120 }} className="text-center">Imagen</th>}
                  {!isScenario3Quiz(quizData) && <th style={{ width: 120 }} className="text-center">{(isScenario52Quiz(quizData) || isScenario52Question2Quiz(quizData)) ? (isScenario52Question2Quiz(quizData) ? "¿Infiltrada?" : "V/F") : isScenario6Quiz(quizData) ? "Correcta para" : isScenario7Quiz(quizData) || isScenario72Quiz(quizData) || isScenario73Quiz(quizData) || isSupertestQuiz(quizData) ? "Correcta" : "Justificada"}</th>}
                  <th style={{ width: 100 }} className="text-center">Acciones</th>
                </tr>
              </thead>
              <tbody>
                {isScenario7Quiz(quizData) ? (
                  [0, 1, 2].map((itemIndex) => {
                    const labels = Array.isArray(editingFilterLabels) && editingFilterLabels.length >= 3 ? editingFilterLabels : DEFAULT_SCENARIO7_FILTER_LABELS;
                    const opts = editingPruebasOptions.slice(itemIndex * 3, itemIndex * 3 + 3);
                    const correctIdx = opts.findIndex((o) => o.correct);
                    return (
                      <tr key={itemIndex}>
                        <td>{itemIndex + 1}</td>
                        <td className="text-truncate" style={{ maxWidth: 320 }} title={labels[itemIndex] ?? ""}>{labels[itemIndex] ?? "—"}</td>
                        <td className="text-center">{correctIdx >= 0 ? `Opción ${correctIdx + 1}` : "—"}</td>
                        <td className="text-center">
                          <Tooltip title="Editar">
                            <Button size="small" onClick={() => openEditOne(itemIndex)}>
                              <EditIcon />
                            </Button>
                          </Tooltip>
                        </td>
                      </tr>
                    );
                  })
                ) : editingPruebasOptions.map((opt, index) => (
                  <tr key={opt.id}>
                    <td>{index + 1}</td>
                    <td className={isSupertestQuiz(quizData) || isScenario2Quiz(quizData) || (isScenario5Quiz(quizData) && !isScenario52Quiz(quizData) && !isScenario52Question2Quiz(quizData)) ? "text-truncate" : (isScenario52Quiz(quizData) || isScenario52Question2Quiz(quizData)) ? "text-truncate" : ""} style={(isSupertestQuiz(quizData) ? { maxWidth: 400 } : undefined) || (isScenario2Quiz(quizData) || (isScenario5Quiz(quizData) && !isScenario52Quiz(quizData) && !isScenario52Question2Quiz(quizData)) ? { maxWidth: 320 } : (isScenario52Quiz(quizData) || isScenario52Question2Quiz(quizData)) ? { maxWidth: 400 } : undefined)}                     title={(isSupertestQuiz(quizData) || isScenario52Quiz(quizData) || isScenario52Question2Quiz(quizData) || isScenario72Quiz(quizData) || isScenario73Quiz(quizData)) ? explanationPreview(opt.text, 200) : isScenario2Quiz(quizData) || isScenario5Quiz(quizData) ? explanationPreview(opt.explanation, 200) : isScenario6Quiz(quizData) ? explanationPreview(opt.text, 200) : undefined}>
                      {isScenario3Quiz(quizData) ? (opt.text || "—") : (isSupertestQuiz(quizData) || isScenario52Quiz(quizData) || isScenario52Question2Quiz(quizData) || isScenario72Quiz(quizData)) ? explanationPreview(opt.text) : isScenario2Quiz(quizData) || isScenario5Quiz(quizData) ? explanationPreview(opt.explanation) : isScenario6Quiz(quizData) ? explanationPreview(opt.text) : (opt.text || "—")}
                    </td>
                    {isScenario3Quiz(quizData) && (
                      <td className="text-center">
                        {opt.image ? <img src={buildImageUrl(opt.image)} alt="" style={{ maxHeight: 48, maxWidth: 80, objectFit: "contain" }} /> : <span className="text-muted">—</span>}
                      </td>
                    )}
                    {!isScenario3Quiz(quizData) && <td className="text-center">{(isScenario52Quiz(quizData) || isScenario52Question2Quiz(quizData) || isScenario72Quiz(quizData) || isScenario73Quiz(quizData)) ? (opt.correct ? (isScenario52Question2Quiz(quizData) ? "Sí" : "V") : (isScenario52Question2Quiz(quizData) ? "No" : "F")) : isScenario6Quiz(quizData) ? (() => { const v = Number(opt.explanation) || 0; const labels = Array.isArray(editingFilterLabels) && editingFilterLabels.length >= 3 ? editingFilterLabels : DEFAULT_SCENARIO6_FILTERS; return v >= 1 && v <= 3 ? (labels[v - 1] || `Filtro ${v}`) : "—"; })() : (opt.correct ? "Sí" : "No")}</td>}
                    <td className="text-center">
                      <div className="d-flex align-items-center justify-content-center gap-1">
                        <Tooltip title="Editar">
                          <Button size="small" onClick={() => openEditOne(index)}>
                            <EditIcon />
                          </Button>
                        </Tooltip>
                        {isSupertestQuiz(quizData) && editingPruebasOptions.length > 1 && (
                          <Tooltip title="Quitar opción">
                            <Button size="small" disabled={savingPruebas} onClick={() => removeSupertestOption(index)}>
                              <DeleteOutlineIcon />
                            </Button>
                          </Tooltip>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="d-flex gap-2 mt-4 flex-wrap align-items-center">
            {isSupertestQuiz(quizData) && (
              <Button variant="contained" color="primary" size="small" startIcon={<AddIcon />} onClick={addSupertestOption}>
                Añadir opción
              </Button>
            )}
            <Button variant="outlined" onClick={() => history.push("/quizzes")}>
              Volver a Quizzes
            </Button>
          </div>
        </CardBody>
      </Card>

      <Dialog open={editingIndex != null} onClose={closeEditOne} maxWidth="md" fullWidth scroll="paper">
        <DialogTitle>{(isScenario72Quiz(quizData) || isScenario73Quiz(quizData)) ? "Editar afirmación (enunciado, V/F y cita)" : isScenario7Quiz(quizData) ? `Editar apartado ${editingIndex != null ? editingIndex + 1 : ""}` : isSupertestQuiz(quizData) ? `Editar opción ${editingIndex != null ? editingIndex + 1 : ""}` : isScenario3Quiz(quizData) ? "Editar opción (etiqueta e imagen)" : `Editar prueba ${editingIndex != null ? editingIndex + 1 : ""}`}</DialogTitle>
        <DialogContent>
          {editingOne && (
            <div className="py-2">
              {(isScenario72Quiz(quizData) || isScenario73Quiz(quizData)) ? (
                <>
                  <div className="form-group">
                    <label className="small">Enunciado de la afirmación (texto que ve el usuario)</label>
                    <div style={{ minHeight: 120 }}>
                      <Editor
                        key={`scenario72-text-${editingOne.id}`}
                        body={editingOne.text || ""}
                        setBody={(v) => updateEditingOne("text", v)}
                        placeholder="Enunciado..."
                        lang="es"
                      />
                    </div>
                  </div>
                  <div className="form-group">
                    <label className="small">¿La afirmación es verdadera o falsa?</label>
                    <div className="d-flex gap-3 mt-1">
                      <label className="d-flex align-items-center">
                        <input
                          type="radio"
                          name="scenario72-correct"
                          checked={!!editingOne.correct}
                          onChange={() => updateEditingOne("correct", true)}
                        />
                        <span className="ml-1">Verdadera</span>
                      </label>
                      <label className="d-flex align-items-center">
                        <input
                          type="radio"
                          name="scenario72-correct"
                          checked={editingOne.correct === false}
                          onChange={() => updateEditingOne("correct", false)}
                        />
                        <span className="ml-1">Falsa</span>
                      </label>
                    </div>
                  </div>
                  <div className="form-group">
                    <label className="small">Justificación (se muestra en el modal tras responder)</label>
                    <div style={{ minHeight: 120 }}>
                      <Editor
                        key={`scenario72-expl-${editingOne.id}`}
                        body={editingOne.explanation || ""}
                        setBody={(v) => updateEditingOne("explanation", v)}
                        placeholder="Justificación..."
                        lang="es"
                      />
                    </div>
                  </div>
                  <div className="form-group">
                    <label className="small">Cita (se muestra bajo el enunciado en la pantalla, p. ej. EULAR y referencia)</label>
                    <div style={{ minHeight: 100 }}>
                      <Editor
                        key={`scenario72-cita-${editingOne.id}`}
                        body={editingOne.confirmExplanation || ""}
                        setBody={(v) => updateEditingOne("confirmExplanation", v)}
                        placeholder="Cita (ej. Fanouriakis A, et al. ... EULAR: European Alliance...)"
                        lang="es"
                      />
                    </div>
                  </div>
                </>
              ) : isScenario7Quiz(quizData) ? (
                <>
                  <div className="form-group">
                    <label className="small">Título del apartado</label>
                    <input
                      type="text"
                      className="form-control"
                      value={editingOne.label || ""}
                      onChange={(e) => updateEditingOne("label", e.target.value)}
                    />
                  </div>
                  <div className="form-group">
                    <label className="small">Opción 1</label>
                    <input
                      type="text"
                      className="form-control"
                      value={editingOne.options && editingOne.options[0] ? editingOne.options[0].text : ""}
                      onChange={(e) => updateEditingOne("option0", e.target.value)}
                    />
                  </div>
                  <div className="form-group">
                    <label className="small">Opción 2</label>
                    <input
                      type="text"
                      className="form-control"
                      value={editingOne.options && editingOne.options[1] ? editingOne.options[1].text : ""}
                      onChange={(e) => updateEditingOne("option1", e.target.value)}
                    />
                  </div>
                  <div className="form-group">
                    <label className="small">Opción 3</label>
                    <input
                      type="text"
                      className="form-control"
                      value={editingOne.options && editingOne.options[2] ? editingOne.options[2].text : ""}
                      onChange={(e) => updateEditingOne("option2", e.target.value)}
                    />
                  </div>
                  <div className="form-group">
                    <label className="small">¿Cuál es la opción correcta?</label>
                    <div className="d-flex gap-3 mt-1">
                      {[0, 1, 2].map((i) => (
                        <label key={i} className="d-flex align-items-center">
                          <input
                            type="radio"
                            name="correctIndex"
                            checked={editingOne.options && editingOne.options[i] && editingOne.options[i].correct}
                            onChange={() => updateEditingOne("correctIndex", i)}
                          />
                          <span className="ml-1">Opción {i + 1}</span>
                        </label>
                      ))}
                    </div>
                  </div>
                </>
              ) : isSupertestQuiz(quizData) ? (
                <>
                  <div className="form-group">
                    <label className="small">Texto de la opción (en la web se muestra como a), b), c)... según el orden)</label>
                    <div style={{ minHeight: 120 }}>
                      <Editor
                        key={`supertest-${editingOne.id}`}
                        body={editingOne.text || ""}
                        setBody={(v) => updateEditingOne("text", v)}
                        placeholder="Texto de la opción..."
                        lang="es"
                      />
                    </div>
                  </div>
                  <div className="form-group form-check">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="edit-one-supertest-correct"
                      checked={!!editingOne.correct}
                      onChange={(e) => updateEditingOne("correct", e.target.checked)}
                    />
                    <label className="form-check-label" htmlFor="edit-one-supertest-correct">
                      Es la respuesta correcta
                    </label>
                  </div>
                </>
              ) : isScenario3Quiz(quizData) ? (
                <>
                  <div className="form-group">
                    <label className="small">Etiqueta (texto que ve el usuario)</label>
                    <input
                      type="text"
                      className="form-control"
                      value={editingOne.text || ""}
                      onChange={(e) => updateEditingOne("text", e.target.value)}
                    />
                  </div>
                  <div className="form-group">
                    <label className="small">Imagen (la que corresponde a esta etiqueta)</label>
                    <div className="d-flex align-items-center gap-3">
                      {editingOne.image && (
                        <img src={buildImageUrl(editingOne.image)} alt="" style={{ maxHeight: 120, maxWidth: 160, objectFit: "contain", border: "1px solid #ddd" }} />
                      )}
                      <div>
                        <input
                          type="file"
                          accept="image/*"
                          className="form-control-file"
                          onChange={async (e) => {
                            const input = e.target;
                            const file = input?.files?.[0];
                            if (!file) return;
                            try {
                              const res = await uploadSingleFile(file, "scenario3-quiz");
                              if (res?.status === 200 && res.data?.fileURL) {
                                updateEditingOne("image", res.data.fileURL);
                              } else {
                                alertError({ customMessage: "No se pudo subir la imagen." });
                              }
                            } catch (err) {
                              alertError({ error: err, customMessage: "Error al subir la imagen." });
                            }
                            if (input) input.value = "";
                          }}
                        />
                        {editingOne.image && (
                          <Button size="small" color="secondary" onClick={() => updateEditingOne("image", "")} className="mt-1">
                            Quitar imagen
                          </Button>
                        )}
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  {isScenario2Quiz(quizData) ? (
                    <div className="form-group">
                      <label className="small">Nombre</label>
                      <div className="form-control-plaintext font-weight-bold">Diagnóstico {editingIndex + 1}</div>
                    </div>
                  ) : (isScenario52Quiz(quizData) || isScenario52Question2Quiz(quizData)) ? (
                    <div className="form-group">
                      <label className="small">Afirmación (texto que ve el usuario)</label>
                      <Editor
                        key={`text-52-${editingOne.id}`}
                        body={editingOne.text || ""}
                        setBody={(v) => updateEditingOne("text", v)}
                        placeholder="Texto de la afirmación..."
                        lang="es"
                      />
                    </div>
                  ) : isScenario5Quiz(quizData) ? (
                    <div className="form-group">
                      <label className="small">Opción (en la web el orden es aleatorio y la letra a)/b)/c)/d) se asigna por posición)</label>
                      <div className="form-control-plaintext font-weight-bold">Opción {editingIndex + 1}</div>
                    </div>
                  ) : isScenario6Quiz(quizData) ? (
                    <div className="form-group">
                      <label className="small">Texto de la recomendación</label>
                      <div style={{ minHeight: 120 }}>
                        <Editor
                          key={`text-6-${editingOne.id}`}
                          body={editingOne.text || ""}
                          setBody={(v) => updateEditingOne("text", v)}
                          placeholder="Texto de la recomendación..."
                          lang="es"
                        />
                      </div>
                    </div>
                  ) : (
                    <div className="form-group">
                      <label className="small">Nombre</label>
                      <input
                        type="text"
                        className="form-control"
                        value={editingOne.text || ""}
                        onChange={(e) => updateEditingOne("text", e.target.value)}
                      />
                    </div>
                  )}
                  {isScenario6Quiz(quizData) ? (
                    <div className="form-group">
                      <label className="small">Correcta para filtro</label>
                      <select
                        className="form-control"
                        value={Number(editingOne.correct) || 0}
                        onChange={(e) => updateEditingOne("correct", Number(e.target.value))}
                      >
                        <option value={0}>Ninguna</option>
                        <option value={1}>{Array.isArray(editingFilterLabels) && editingFilterLabels[0] != null ? editingFilterLabels[0] : DEFAULT_SCENARIO6_FILTERS[0]}</option>
                        <option value={2}>{Array.isArray(editingFilterLabels) && editingFilterLabels[1] != null ? editingFilterLabels[1] : DEFAULT_SCENARIO6_FILTERS[1]}</option>
                        <option value={3}>{Array.isArray(editingFilterLabels) && editingFilterLabels[2] != null ? editingFilterLabels[2] : DEFAULT_SCENARIO6_FILTERS[2]}</option>
                      </select>
                    </div>
                  ) : (
                  <div className="form-group form-check">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="edit-one-justified"
                      checked={!!editingOne.correct}
                      onChange={(e) => updateEditingOne("correct", e.target.checked)}
                    />
                    <label className="form-check-label" htmlFor="edit-one-justified">
                      {isScenario52Quiz(quizData) ? "Verdadera (desmarca si es Falsa)" : isScenario52Question2Quiz(quizData) ? "Es la afirmación infiltrada" : "Está justificada"}
                    </label>
                  </div>
                  )}
                  {!isScenario6Quiz(quizData) && (
                    <>
                  <div className="form-group">
                    <label className="small">{(isScenario52Quiz(quizData) || isScenario52Question2Quiz(quizData)) ? (isScenario52Quiz(quizData) ? "Justificación (se muestra al completar; en falsas explica el dato correcto)" : "Justificación (opcional)") : "Justificación (solo contenido; la frase inicial se genera según si está justificada)"}</label>
                    <div style={{ minHeight: 120 }}>
                      <Editor
                        key={`expl-${editingOne.id}`}
                        body={editingOne.explanation || ""}
                        setBody={(v) => updateEditingOne("explanation", v)}
                        placeholder="HTML o texto de la justificación..."
                        lang="es"
                      />
                    </div>
                  </div>
                  <div className="form-group">
                    <label className="small">Confirmación previa (opcional)</label>
                    <div style={{ minHeight: 80 }}>
                      <Editor
                        key={`conf-${editingOne.id}`}
                        body={editingOne.confirmExplanation || ""}
                        setBody={(v) => updateEditingOne("confirmExplanation", v)}
                        placeholder="Opcional..."
                        lang="es"
                      />
                    </div>
                  </div>
                    </>
                  )}
                </>
              )}
            </div>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={closeEditOne} disabled={savingPruebas}>Cancelar</Button>
          <Button onClick={saveEditOne} color="primary" variant="contained" disabled={savingPruebas}>
            {savingPruebas ? "Guardando…" : "Guardar"}
          </Button>
        </DialogActions>
      </Dialog>

      {isSupertestQuiz(quizData) && (
        <Dialog open={supertestEditField != null} onClose={() => setSupertestEditField(null)} maxWidth="md" fullWidth scroll="paper">
          <DialogTitle>
            {supertestEditField === "screenTitle" && "Editar título (enunciado) de la pregunta"}
            {supertestEditField === "legend" && "Editar leyenda"}
            {supertestEditField === "resultExplanation" && "Editar texto en el modal de resultado (justificación)"}
          </DialogTitle>
          <DialogContent>
            <div className="py-2">
              {supertestEditField === "screenTitle" && (
                <div className="form-group">
                  <label className="small">Texto que se muestra en la web como enunciado de esta pregunta.</label>
                  <div style={{ minHeight: 120 }}>
                    <Editor
                      key={`supertest-dialog-screenTitle-${quizData._id}`}
                      body={supertestScreenTitle || ""}
                      setBody={(v) => setSupertestScreenTitle(v ?? "")}
                      placeholder="Ej.: ¿Cuál de las siguientes afirmaciones NO es correcta?"
                      lang="es"
                    />
                  </div>
                </div>
              )}
              {supertestEditField === "legend" && (
                <div className="form-group">
                  <label className="small">Texto bajo las opciones (p. ej. NL: nefritis lúpica; LES: lupus eritematoso sistémico).</label>
                  <div style={{ minHeight: 120 }}>
                    <Editor
                      key={`supertest-dialog-legend-${quizData._id}`}
                      body={supertestLegend || ""}
                      setBody={(v) => setSupertestLegend(v ?? "")}
                      placeholder="Ej.: NL: nefritis lúpica; LES: lupus eritematoso sistémico"
                      lang="es"
                    />
                  </div>
                </div>
              )}
              {supertestEditField === "resultExplanation" && (
                <div className="form-group">
                  <label className="small">Justificación que se muestra en el modal al final como &quot;Pregunta 1/2/3: …&quot;</label>
                  <div style={{ minHeight: 180 }}>
                    <Editor
                      key={`supertest-dialog-resultExplanation-${quizData._id}`}
                      body={supertestResultExplanation || ""}
                      setBody={(v) => setSupertestResultExplanation(v ?? "")}
                      placeholder="Ej.: todas las afirmaciones son correctas. Cabe destacar que la NL se caracteriza por..."
                      lang="es"
                    />
                  </div>
                </div>
              )}
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setSupertestEditField(null)}>Cancelar</Button>
            <Button
              color="primary"
              variant="contained"
              disabled={supertestEditField === "screenTitle" || supertestEditField === "legend" ? savingSupertestTitleLegend : savingSupertestResult}
              onClick={async () => {
                if (supertestEditField === "screenTitle" || supertestEditField === "legend") {
                  await saveSupertestTitleLegend();
                } else if (supertestEditField === "resultExplanation") {
                  await saveSupertestResultExplanation();
                }
                setSupertestEditField(null);
              }}
            >
              {(supertestEditField === "screenTitle" || supertestEditField === "legend" ? savingSupertestTitleLegend : savingSupertestResult) ? "Guardando…" : "Guardar"}
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
}
